module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "z-index-full",
    attrs: {
      "name": "WrapperModal",
      "width": "1000",
      "height": "auto",
      "min-height": 500,
      "min-width": 300,
      "resizable": true,
      "scrollable": true,
      "reset": true,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.modal.title) + "\n    ")]), _vm._v(" "), _c(_vm.getComponent.compoment, _vm._b({
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    tag: "component",
    on: {
      "mounted": _vm.compomentIsReady
    }
  }, 'component', _vm.extra, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-132f6d8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Modals.vue
// module id = 738
// module chunks = 7